import { useLocation } from 'react-router';

import { Breadcrumbs } from '../components/Breadcrumbs';
import { DashboardNavigator } from '../components/DashboardNavigator';
import { Filters } from '../components/filters/Filters';

export const Header = () => {
  const location = useLocation();
  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full">
      <Breadcrumbs />
      <DashboardNavigator />
      <Filters
        enablePracticeFilter={true}
        enableProviderRoleFilter={!location.pathname.includes('hygiene')}
        enableTasksFilter={location.pathname.includes('hygiene')}
        enableMaterialityFilter={location.pathname.includes('clinical')}
      />
    </div>
  );
};
